import { Assignment } from '@models/performance/assignment.model';
import { SurveyResponse } from '@models/performance/survey-response.model';

export class SurveyAssignment extends Assignment {
    get response(): SurveyResponse {
        return this.hasOne(SurveyResponse, 'response');
    }
}
